module.exports = __webpack_public_path__ + "img/files.beedb1e7.svg";